export default "__VITE_ASSET__BrH$GkoB__"